/**
 * Password rule: at least 6 characters, including at least one letter, one number
 * and one symbol.
 *
 *   letter  = any Unicode letter, so ä é ò ç ł count as letters (never as symbols)
 *   number  = 0-9
 *   symbol  = not a letter, mark, number, underscore or whitespace. Underscore and
 *             space are excluded to match the backend's ComplexityValidator, whose
 *             special class is [^\w\s] — see server/commitly/utils.py.
 *
 *             Do NOT simplify this to [^\w\s] to mirror that backend source. Python's
 *             \w is Unicode-aware, JavaScript's is fixed at [A-Za-z0-9_] even with the
 *             /u flag, so in JS it would classify é, ß, ç and П as symbols. "paßwort1"
 *             would then pass here with no symbol at all, and still be rejected by the
 *             server. [^\p{L}\p{M}\p{N}_\s] is the JS translation of [^\w\s], not a
 *             more complicated alternative to it.
 *   allowed = printable ASCII + Unicode letters + combining marks. A space is allowed
 *             inside the password but not as the first or last character.
 *
 * Split across two strings because the single-literal form exceeds the 140-char line
 * limit. Behaviour is locked by patterns.spec.ts — change neither without the other.
 */
const PASSWORD_REQUIRED_CLASSES = '^(?=.*\\p{L})(?=.*[0-9])(?=.*[^\\p{L}\\p{M}\\p{N}_\\s])(?=.{6,}$)';
const PASSWORD_ALLOWED_BODY = '[\\x21-\\x7E\\p{L}\\p{M}](?:[\\x20-\\x7E\\p{L}\\p{M}]*[\\x21-\\x7E\\p{L}\\p{M}])?$';

export const PASSWORD_PATTERN = new RegExp(PASSWORD_REQUIRED_CLASSES + PASSWORD_ALLOWED_BODY, 'u');
export const NUMBERS_PATTERN = /^-?\d*[,.]?\d{1,}$/;
export const EMAIL_PATTERN = '(?:[a-za-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+(?:\\.[a-za-zA-Z0-9!#$%&\'*+\\/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-za-zA-Z0-9](?:[a-za-zA-Z0-9-]*[a-za-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-za-zA-Z0-9-]*[a-zA-Z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])';
export const EMAIL_USER_NAME_PATTERN = /^[a-zA-Z0-9+_-]+(?:\.[a-zA-Z0-9+_-]+)*$/;
export const DECIMAL_POSITIVE_PATTERN = /^\d+([,.]\d+)?$/;
